import type { OrderInfoResponseItemType } from './orderInfoResponseItemType';
import type { OrderInfoResponseOrderType } from './orderInfoResponseOrderType';
import type { OrderInfoResponseStatus } from './orderInfoResponseStatus';

/**
 * 주문 정보 조회 응답
 */
export interface OrderInfoResponse {
  /** 결제 금액 */
  amount?: number;
  /** 주문 생성일시 */
  createdAt?: string;
  /**
   * 오류 코드 (실패 시)
   * @nullable
   */
  errorCode?: string | null;
  /** 상품명 */
  goodsName?: string;
  /** 아이템 유형 */
  itemType?: OrderInfoResponseItemType;
  /** 응답 메시지 */
  message: string;
  /** 주문 ID */
  orderId?: string;
  /** 주문 유형 */
  orderType?: OrderInfoResponseOrderType;
  /**
   * Edusense 강의와 연결된 상품 코드
   * @nullable
   */
  productCode?: string | null;
  /** 주문 상태 */
  status?: OrderInfoResponseStatus;
  /** 성공 여부 */
  success: boolean;
  /** 주문한 사용자 ID */
  userId?: string;
}
